
<div class="container" style="border:1px solid #bebaba">
  <br />
  
  <div class="row indentContent">
    <div class="col-md-12">
      <h3 style="font-weight:bold">Claim Form</h3>
      <p>Please use the links below for copies of the Claim Form.</p>
      <ul>
        <li>
          <a href="../../../assets/documents/Burke v. Visa_Claim Form_FINAL.pdf"
             target="_blank">
            Claim Form
          </a>
        </li>
        <li>
          <a href="../../../assets/documents/Burke v. Visa_Claim Form_FINAL_ES(US).pdf"
             target="_blank">
            Formulario de Reclamación en Español
          </a>
        </li>
      </ul>
    </div>
  </div>
  <div style="width:80%; margin:0 auto; text-align: center; display:block; margin-top: 2%">
    <p>
      Note: These documents are in PDF format. To view the<br />
      documents, you will need <a href="https://get.adobe.com/reader/" target="_blank"
                                  style="color:#0071ce; font-weight:bold">Adobe Acrobat Reader</a>
      on your computer or other internet-enabled device.
    </p>
  </div>
  <div class="row text-center" id="inverse_row">
    <div class="col-md-12">
      <a href="https://get.adobe.com/reader/" target="_blank"><img src="../assets/adobe-pdf-icon.jpg" alt="Adobe Acrobat Reader" width="3%"></a>
    </div>
  </div>
  <br />
</div>
